export function Button({children, variant = 'solid', className = '', ...props}) {
    const baseStyles =
        'rounded px-4 py-2 font-semibold focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50';

    const variants = {
        solid: 'bg-button text-white hover:bg-green-700 focus:ring-black-500 rounded-lg',
        menu: 'bg-button text-white hover:bg-green-700 focus:ring-black-500 rounded-lg',
        ghost: 'bg-transparent text-white hover:bg-white hover:text-indigo-600 focus:ring-white',
        danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 rounded-lg',
        outline: 'flex-1 border border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
    };

    const styles = `${baseStyles} ${variants[variant] || variants.solid} ${className}`;

    return (
        <button className={styles} {...props}>
            {children}
        </button>
    );
}
